/**
 * Resolve um seletor para o PRIMEIRO elemento *visível*, não o primeiro do DOM.
 *
 * A Inbox monta várias cópias da mesma lista (mobile `md:hidden` + desktop
 * `hidden md:block`, em painéis diferentes), então toda âncora existe também em
 * cópias ocultas (`display:none`). Um `querySelector` puro pegaria uma cópia oculta
 * primeiro, `getBoundingClientRect()` devolveria `{0,0,0,0}` e o destaque
 * colapsaria num ponto no canto da tela. Pular quem tem tamanho zero escolhe a que
 * a pessoa realmente enxerga.
 *
 * Usado pelo tour guiado (`onboarding/Spotlight`) e pelas novidades
 * (`featureSpotlight`).
 *
 * @param {string} selector
 * @returns {Element|null}
 */
export function findVisibleTarget(selector) {
  if (!selector) return null;
  for (const el of document.querySelectorAll(selector)) {
    const r = el.getBoundingClientRect();
    if (r.width > 0 && r.height > 0) return el;
  }
  return null;
}
